<template>
  <v-dialog :value="show" max-width="600px" @input="$emit('close')">
    <v-card>
      <v-card-title>{{ $t('security_link_new_park') }}</v-card-title>
      
      <v-card-text>
        <v-progress-linear v-if="isSecurityLoading" indeterminate></v-progress-linear>
        
        <v-alert v-if="getSecurityError" type="error" dismissible>
          {{ getSecurityError }}
        </v-alert>

        <v-form @submit.prevent="linkPark" v-if="!isSecurityLoading">
          <v-layout row wrap>
            <v-flex xs12>
              <p class="caption">{{ $t('security_select_park_description') }}</p>
            </v-flex>

            <v-flex xs12>
              <v-autocomplete
                v-model="selectedPark"
                :items="availableParks"
                :loading="isLoadingParks"
                item-text="nombre"
                item-value="id"
                :label="$t('security_select_park')"
                placeholder="Busca un parque..."
                no-data-text="No hay parques disponibles"
                @input="validateForm"
              >
                <template slot="item" slot-scope="data">
                  <div>
                    <strong>{{ data.item.nombre }}</strong>
                    <br />
                    <small>{{ data.item.ubicacion }}</small>
                  </div>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 v-if="selectedPark">
              <v-card class="mt-3">
                <v-card-text>
                  <v-list dense>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $t('park_name') }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ selectedParkDetails.nombre }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $t('location') }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ selectedParkDetails.ubicacion }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="$emit('close')">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn 
          color="primary" 
          flat 
          @click="linkPark"
          :loading="isSecurityLoading"
          :disabled="!selectedPark"
        >
          {{ $t('security_send_request') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { LINK_PARK } from '../../../store/modules/security'
import { mapGetters } from 'vuex'

export default {
  name: 'LinkParkModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedPark: null,
      availableParks: [],
      isLoadingParks: false
    }
  },
  computed: {
    ...mapGetters(['getToken']),
    ...mapGetters('security', ['isSecurityLoading', 'getSecurityError']),
    selectedParkDetails() {
      if (!this.selectedPark) return {}
      return this.availableParks.find(p => p.id === this.selectedPark) || {}
    }
  },
  methods: {
    validateForm() {
      // Validación implícita en el botón disabled
    },
    linkPark() {
      if (!this.selectedPark) {
        this.$store.commit('snackbar_change_message', this.$t('security_select_park_first'))
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_activate_true')
        return
      }

      this.$store.dispatch(`security/${LINK_PARK}`, {
        token: this.getToken,
        parkId: this.selectedPark
      })
      .then(() => {
        this.selectedPark = null
        this.$emit('success')
      })
      .catch(err => {
        // Error ya está en getSecurityError
      })
    },
    fetchAvailableParks() {
      // TODO: Cuando exista endpoint de parques disponibles
      // Por ahora se carga desde el backend si existe
      this.isLoadingParks = true
      // Simular carga
      setTimeout(() => {
        this.isLoadingParks = false
      }, 500)
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.selectedPark = null
        this.fetchAvailableParks()
      }
    }
  }
}
</script>

<style scoped>
.mt-3 {
  margin-top: 20px;
}
.caption {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
